import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../../common.module.scss";
import { Aviation } from "../../../../../services";
import OrdersInfoCargo from "../OrdersInfoCargo";
import OrdersInfoHeader from "../OrdersInfoHeader";
import OrdersInfoBasic from "../OrdersInfoBasic";
import OrdersInfoDirections from "../OrdersInfoDirections";
import Loading from "../../../../shared/Loading/Loading";
import { toast } from "react-toastify";
import SuggestPrice from "../SuggestPrice";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import OrdersChatHub from "../../../../shared/chat/OrdersChatHub";
import { useLanguage } from "../../../../../context/LanguageContext";

const OrderInfoAviationMobileMarketplace = ({ isOpen, tenderOrderInfo }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const { currentLanguage } = useLanguage();
  const params = useParams();
  const navigate = useNavigate();
  const orderId = params.id;

  const [getOrder, setOrder] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const [isOpenChatModal, setIsOpenChatModal] = useState(false);

  const onForceUpdate = () => {
    fetchOrderData();
  };

  const fetchOrderData = async () => {
    setLoading(true);
    if (orderId) {
      try {
        const { data } = await Aviation.getAirOrdersById(orderId, currentLanguage);
        if (data.shippingDate) {
          let date = data.shippingDate.split("T");
          const timeStart = data.shippingHourFrom < 10 ? `0${data.shippingHourFrom}` : data.shippingHourFrom;
          const timeEnd = data.shippingHourTo < 10 ? `0${data.shippingHourTo}` : data.shippingHourTo;
          data.shippingDate = `${date[0]}T${timeStart}:00:00`;
          data.shippingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        if (data.unloadingDate) {
          let date = data.unloadingDate.split("T");
          const timeStart =
            data.unloadingHourFrom < 10 ? `0${data.unloadingHourFrom}` : data.unloadingHourFrom;
          const timeEnd = data.unloadingHourTo < 10 ? `0${data.unloadingHourTo}` : data.unloadingHourTo;
          data.unloadingDate = `${date[0]}T${timeStart}:00:00`;
          data.unloadingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        setOrder(data);
        console.log("[DATA]", data);
      } catch (e) {
        console.log(e);
        toast.error(t("orderInfo.genericError"));
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setUnreadMessagesCount(0);

    if (getOrder) {
      Aviation.getUnreadMessages(getOrder.id)
        .then((response) => {
          if (response.status === 200) {
            setUnreadMessagesCount(response.data?.count || 0);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [getOrder]);

  useEffect(() => {
    fetchOrderData();
  }, [orderId]);

  return (
    <div className={cn(style.wrapper_mobile)}>
      {getOrder && (
        <>
          <OrdersInfoHeader item={getOrder} onForceUpdate={onForceUpdate} />
          {isLoading ? <Loading borderRadius="16px" /> : null}

          {isOpenChatModal && getOrder && (
            <OrdersChatHub
              isOpen={isOpenChatModal}
              orderData={getOrder}
              orderId={getOrder.id}
              orderNumber={getOrder.number}
              onClose={() => setIsOpenChatModal(false)}
              serviceType="aviation"
            />
          )}

          {getOrder.status !== "awaitingoffer" ? (
            <div className={style.orders_content} style={{ textAlign: "center", padding: "40px 20px" }}>
              <h3 style={{ marginBottom: "16px", fontSize: "18px", fontWeight: "600" }}>
                {t("orderInfo.tenderClosed")}
              </h3>
              <p style={{ marginBottom: "24px", color: "#666" }}>{t("orderInfo.orderNotAvailable")}</p>
              <CustomButton isFall text={t("orderBooking.button.back")} onClick={() => navigate(-1)} />
            </div>
          ) : (
            <div className={style.orders_content}>
              <OrdersInfoBasic
                item={getOrder}
                onOpen={() => setIsOpenModalHistory(true)}
                onOpenChat={() => setIsOpenChatModal(true)}
                unreadCount={unreadMessagesCount}
                isMarketplacePage
              />

              {getOrder && (
                <OrdersInfoDirections
                  item={getOrder}
                  senderName={getOrder?.senderName}
                  recipientName={getOrder?.recipientName}
                  isMarketplacePage
                />
              )}

              {user?.type === "Expeditor" && getOrder && (
                <SuggestPrice
                  onRefreshOrder={fetchOrderData}
                  item={getOrder}
                  onUpdateData={() => onForceUpdate()}
                  tenderOrderInfo={tenderOrderInfo || []}
                />
              )}

              <OrdersInfoCargo getOrder={getOrder} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default OrderInfoAviationMobileMarketplace;
